import Button from '@jetbrains/ring-ui/components/button/button'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import classNames from 'classnames'
import * as React from 'react'

import type {BuildId} from '../../../../../types'
import AgentInfo from '../../../../common/AgentInfo/AgentInfo.container'
import BuildCanceled from '../../../../common/BuildCanceled/BuildCanceled.container'
import BuildPersonal from '../../../../common/BuildPersonal/BuildPersonal.container'
import BuildPinInfo from '../../../../common/BuildPinInfo/BuildPinInfo.container'
import BuildQueueInfo from '../../../../common/BuildQueueInfo/BuildQueueInfo.container'
import BuildTimeInfo from '../../../../common/BuildTimeInfo/BuildTimeInfo.container'
import BuildTriggeredBy from '../../../../common/BuildTriggeredBy/BuildTriggeredBy.container'
import Popup from '../../../../common/Popup/Popup.lazy'
import BuildTagsList from '../../../../common/TagsList/TagsList.container'
import Visible from '../../../../common/Visible/Visible'
import BuildComment from '../../BuildComment/BuildComment.container'

import styles from './BuildDetailsPopup.css'

const POPUP_DIRECTIONS = [
  Directions.BOTTOM_RIGHT,
  Directions.TOP_RIGHT,
  Directions.BOTTOM_CENTER,
  Directions.TOP_CENTER,
  Directions.BOTTOM_RIGHT,
  Directions.TOP_RIGHT,
]

type Props = {
  className?: string
  buildId: BuildId
}

function BuildDetailsPopup({className, buildId}: Props) {
  const anchor = <Button dropdown>{`Details`}</Button>
  return (
    <Dropdown anchor={anchor} hoverMode className={classNames(className, styles.wrapper)}>
      <Popup directions={POPUP_DIRECTIONS}>
        <div className={styles.content}>
          <Visible className={styles.visibleContainer}>
            {() => (
              <table className={styles.info}>
                <tbody>
                  <BuildTimeInfo buildId={buildId} />
                  <AgentInfo buildId={buildId} withLabel />
                  <BuildTriggeredBy inTable buildId={buildId} inline={false} withFullDate />
                </tbody>
              </table>
            )}
          </Visible>
          <BuildPersonal className={styles.row} buildId={buildId} withIcon />
          <BuildCanceled className={styles.row} buildId={buildId} compact withIcon />
          <BuildPinInfo className={styles.row} buildId={buildId} compact withIcon />
          <BuildComment className={styles.row} buildId={buildId} compact withIcon />
          <BuildTagsList className={styles.row} buildId={buildId} withIcon />
          <div className={styles.row}>
            <BuildQueueInfo
              className={styles.buildQueueInfo}
              buildId={buildId}
              highlightText={false}
              inline
            />
          </div>
        </div>
      </Popup>
    </Dropdown>
  )
}

export default React.memo<Props>(BuildDetailsPopup)
